import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import { useEffect, useRef } from 'react';

import { getObserver } from '../ElementInViewport/utils';

import * as styles from './FiltersTabs.css';

export interface IFiltersTabsProps {
  items: IFiltersTabProps[];
}

export interface IFiltersTabProps {
  label: string;
  url: string;
  isSelected: Boolean;
  clickHandler(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void;
  target?: string;
  dataTestid?: string;
  onVisible?: () => void;
}

const FiltersTabListItem: React.FC<IFiltersTabProps> = ({
  label,
  isSelected,
  url,
  clickHandler,
  target,
  dataTestid,
  onVisible,
}) => {
  const liRef = useRef<HTMLLIElement>(null);
  const hasTrackedVisibility = useRef(false);

  useEffect(() => {
    if (!onVisible || !liRef.current) {
      return;
    }

    const handleVisible = () => {
      if (hasTrackedVisibility.current) {
        return;
      }
      hasTrackedVisibility.current = true;
      onVisible();
    };

    return getObserver()({
      target: liRef.current,
      threshold: 0.5,
      onVisible: handleVisible,
    });
  }, [onVisible]);

  return (
    <li ref={liRef} {...mergeStyles(styles['list-element'], isSelected && styles['list-element--active'])}>
      <a href={url} onClick={event => clickHandler(event)} target={target} data-testid={dataTestid}>
        {label}
      </a>
    </li>
  );
};

export const FiltersTabs: React.FC<IFiltersTabsProps> = ({ items }) => (
  <ul className={styles['list']} data-mark="FiltersTabs">
    {items.map(({ label, isSelected, url, clickHandler, target, dataTestid, onVisible }) => (
      <FiltersTabListItem
        key={`item_${label}`}
        label={label}
        url={url}
        isSelected={isSelected}
        clickHandler={clickHandler}
        target={target}
        dataTestid={dataTestid}
        onVisible={onVisible}
      />
    ))}
  </ul>
);
